import {  injectable } from 'inversify';
import { EntityServiceBase } from '@/bases/services/EntityServiceBase';
import { Items } from '@/models';

@injectable()
export class ItemsService extends EntityServiceBase<Items> {
  public constructor() {
    super();
    this.EntityName = "Items";
  }
}